import React from "react";

const WalletsSkeleton = () => {
  return (
    <div className="bg-white rounded-2xl my-4 shadow-lg animate-pulse">
      {/* Header section */}
      <div className="flex items-center justify-between px-8 pt-6 pb-3">
        <div className="h-6 w-48 bg-gray-200 rounded"></div>
        <div className="flex space-x-2">
          <div className="h-8 w-16 bg-gray-200 rounded"></div>
          <div className="h-8 w-20 bg-gray-200 rounded"></div>
          <div className="h-8 w-32 bg-gray-200 rounded"></div>
        </div>
      </div>

      {/* Wallet cards */}
      <div className="flex overflow-x-auto space-x-5 px-4 py-4">
        {[...Array(5)].map((_, index) => (
          <div
            key={index}
            className="bg-[#EDEFEC] rounded-xl pl-4 pr-4 py-4 flex-shrink-0"
            style={{ width: 200, maxWidth: 200 }}
          >
            <div className="flex items-center space-x-3 text-left pb-4">
              <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
              <div className="h-4 w-16 bg-gray-200 rounded"></div>
            </div>
            <div className="pb-4">
              <div className="h-3 w-24 bg-gray-200 rounded mb-2"></div>
              <div className="h-4 w-28 bg-gray-200 rounded"></div>
            </div>
            <div className="pb-2">
              <div className="h-3 w-24 bg-gray-200 rounded mb-2"></div>
              <div className="h-4 w-28 bg-gray-200 rounded"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WalletsSkeleton;
